import axios from 'axios'
import Cookies from 'js-cookie'
import { toLogin } from '../assets/js/utils'

const errorCode = [2001]

// axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'

let http = axios.create({
	// baseURL: process.env.VUE_APP_API,
	timeout: 30000
})

// 请求拦截器
http.interceptors.request.use(
	config => {
		// config.headers['Authorization'] = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJVc2VyIjp7InQiOiIwODIzMTRiMTM5NmI0NjlhOTYxODk3ZDE1YTQ4ZTAyYyIsImNfdCI6ImN2YzM5NzgwZjhlYmRmNDIzIiwiaF90IjoiaHI5YTVkYjk1NWFmOGE0YjMifSwiZXhwIjoxNjI0OTM2ODkxfQ.6Z_hbJkQb8eAQF2xgkNIJoaDO8v7Vb7eKD9U0sJnH30'
		if (Cookies.get('_t') || Cookies.get('_t_plugin')) {
			config.headers['Authorization'] = Cookies.get('_t') || Cookies.get('_t_plugin')
		}
		config.withCredentials = true
		if (config.method === 'POST' || config.method === 'PUT') {
			// post、put 提交时，将对象转换为string, 为处理Java后台解析问题
			config.data = JSON.stringify(config.data)
		} else if (config.method === 'GET') {
			// 给GET 请求后追加时间戳， 解决IE GET 请求缓存问题
			let symbol = config.url.indexOf('?') >= 0 ? '&' : '?'
			config.url += symbol + '_=' + Date.now()
		}
		return config
	},
	error => {
		return Promise.reject(error)
	}
)
// 响应拦截器
http.interceptors.response.use(
	response => {
		let { data, config: { url } } = response
		if(errorCode.includes(data.code)){
			// 账号不存在时跳转登录页(小程序会有问题)
			// alert(JSON.stringify(response))
			toLogin();
			// Message({
			//   message: '请重新登录',
			//   type: 'error'
			// });
			// setTimeout(() => {
			//   toLogin();
			// }, 1000);
		}
		return data
	},
	error => {
		let info = {}
		let { status, statusText, data } = error.response
		if (!error.response) {
			info = {
				code: 5000,
				msg: 'Network Error'
			}
		} else {
			// 此处整理错误信息格式
			info = {
				code: status,
				data: data,
				msg: statusText
			}
		}
		return Promise.reject(info)
	}
)

export default http
